// extracted by mini-css-extract-plugin
module.exports = {"ArrowRight":"ArrowRight_ArrowRight__eBsSW","ArrowUp":"ArrowRight_ArrowUp__2Jl5J","ArrowDown":"ArrowRight_ArrowDown__QFpzb"};